import type { ContractId, MissionObjective } from "@frontier/content/contracts";

export function navigationCaption(
  contractId: ContractId | undefined,
  objective: MissionObjective,
): string {
  return contractId === "intro" && objective.kind === "combat"
    ? "Налётчик"
    : objective.name;
}
